import { render } from "./VisualEditsPanel.vue?vue&type=template&id=a3247e2e"
import script from "./VisualEditsPanel.vue?vue&type=script&lang=js"
export * from "./VisualEditsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__